import { createFileRoute } from "@tanstack/react-router";

import { WaitingPurchasesPage } from "@/modules/purchases/pages/WaitingPurchases.page";

export const Route = createFileRoute("/__authed/m/purchases/waiting")({
	component: WaitingPurchasesPage,
});
